import { render, staticRenderFns } from "./MarketLivePreview.vue?vue&type=template&id=753ca1ba"
import script from "./MarketLivePreview.vue?vue&type=script&lang=js"
export * from "./MarketLivePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports